import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FlaskConical,
  Package,
  ArrowRight,
  Pill,
  Activity,
  Flame,
  Star,
  ShoppingBag,
} from "lucide-react";

export default function CategorySection() {
  const navigate = useNavigate();
  const [active, setActive] = useState(null);

  const items = [
    {
      name: "Lab Tests",
      icon: <FlaskConical size={22} />,
      route: "/all-tests",
      from: "labtests",
    },
    {
      name: "Packages",
      icon: <Package size={22} />,
      route: "/lab",
      from: "packages",
    },
    // {
    //   name: "Medicines",
    //   icon: <Pill size={22} />,
    //   route: "/medicines",
    //   from: "medicines",
    // },
    {
      name: "Lab",
      icon: <Activity size={22} />,
      route: "/lab",
      from: "lab",
    },
    {
      name: "All Packages",
      icon: <ShoppingBag size={22} />,
      route: "/all-packages",
      from: "all-packages",
    },
    {
      name: "View All",
      icon: <ArrowRight size={22} />,
      route: "/all",
      from: "all",
    },
  ];

  const handleClick = (item, i) => {
    setActive(i);

    const payload = {
      from: item.from,
      name: item.name,
    };

    console.log("🔥 CATEGORY CLICKED:", payload);

    navigate(item.route, {
      state: payload,
    });
  };

  return (
    <div className="px-4 md:px-8 py-6 bg-gradient-to-br from-gray-50 via-white to-red-50/30 rounded-xl shadow-lg mt-3">
      
      {/* Header Section */}
      <div className="text-center mb-6">       
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold">
          <span className="bg-gradient-to-r from-gray-800 to-gray-900 bg-clip-text text-transparent">
            Our
          </span>{" "}
          <span className="bg-gradient-to-r from-red-600 to-red-800 bg-clip-text text-transparent">
            Healthcare Services
          </span>
        </h2>
        
        <p className="text-gray-500 text-sm mt-2 max-w-md mx-auto">
          Book tests, medicines and healthcare services at your doorstep
        </p>

      </div>

      {/* Categories Grid */}
      <div className="grid grid-cols-2 md:grid-cols-6 gap-3 md:gap-2">
        {items.map((item, i) => (
          <div
            key={i}
            onClick={() => handleClick(item, i)}
            className={`
              group cursor-pointer
              flex flex-col items-center justify-center
              py-3 px-2
              transition-all duration-300
              hover:-translate-y-1
              ${i !== items.length - 1 ? "md:border-r border-gray-200" : ""}
            `}
          >
            {/* Icon Circle */}
            <div
              className={`
                w-14 h-14 md:w-16 md:h-16
                rounded-xl
                flex items-center justify-center
                transition-all duration-300
                shadow-md
                ${
                  active === i
                    ? "bg-gradient-to-r from-red-600 to-red-700 shadow-lg"
                    : "bg-gradient-to-r from-red-500 to-red-600 group-hover:from-red-600 group-hover:to-red-700"
                }
              `}
            >
              <div className="text-white transition-transform duration-300 group-hover:scale-110">
                {item.icon}
              </div>
            </div>

            {/* Category Name */}
            <span
              className={`
                mt-2 text-xs md:text-sm font-semibold text-center
                transition-colors duration-300
                ${
                  active === i
                    ? "text-red-600"
                    : "text-gray-700 group-hover:text-red-600"
                }
              `}
            >
              {item.name}
            </span>
            
            {/* Bottom Indicator Line */}
            <div className={`
              w-0 h-0.5 bg-red-500 mt-1 rounded-full
              transition-all duration-300
              ${active === i ? "w-6" : "group-hover:w-4"}
            `}></div>
          </div>
        ))}
      </div>

      {/* Trust Badges */}
      <div className="mt-6 pt-4 border-t border-gray-200">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
          <div className="flex items-center justify-center gap-1.5 text-[10px] text-gray-600 bg-white/50 rounded-lg p-1.5 hover:bg-white transition-all duration-300">
            <div className="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center">
              <span className="text-green-600 text-[9px] font-bold">✓</span>
            </div>
            <span>Free Home Pickup</span>
          </div>
          <div className="flex items-center justify-center gap-1.5 text-[10px] text-gray-600 bg-white/50 rounded-lg p-1.5 hover:bg-white transition-all duration-300">
            <div className="w-5 h-5 bg-blue-100 rounded-full flex items-center justify-center">
              <span className="text-blue-600 text-[9px] font-bold">⚡</span>
            </div>
            <span>Reports in 4 Hours</span>
          </div>
          <div className="flex items-center justify-center gap-1.5 text-[10px] text-gray-600 bg-white/50 rounded-lg p-1.5 hover:bg-white transition-all duration-300">
            <div className="w-5 h-5 bg-purple-100 rounded-full flex items-center justify-center">
              <span className="text-purple-600 text-[9px] font-bold">🏆</span>
            </div>
            <span>NABL Certified</span>
          </div>
          <div className="flex items-center justify-center gap-1.5 text-[10px] text-gray-600 bg-white/50 rounded-lg p-1.5 hover:bg-white transition-all duration-300">
            <div className="w-5 h-5 bg-red-100 rounded-full flex items-center justify-center">
              <span className="text-red-600 text-[9px] font-bold">❤️</span>
            </div>
            <span>10L+ Customers</span>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.6; transform: scale(1.05); }
        }
        .animate-pulse {
          animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
      `}</style>
    </div>
  );
}